export default {
    rules: (wrapper) => ({
        name_first: {label: wrapper.$t('form.first_name'), required: true},
        name_infix: {label: wrapper.$t('form.infix_name')},
        name_last: {label: wrapper.$t('form.last_name'), required: true},
        email: {label: wrapper.$t('form.email'), type: 'email', required: true},
    }),
};
